export interface ErrorReport {
    message: string;
    traceId?: string;
    originalError: any;
}

export function reportError(error: any): ErrorReport {
    // In a real app, this would send to Sentry or similar
    console.error('Reported Error:', error);

    return {
        message: error.message || String(error),
        traceId: error.traceId, // Assuming some errors might carry this
        originalError: error,
    };
}
